// Owner-provided configuration values.
//
// ORG_MAILING_ADDRESS: BHWCI's postal mailing address for the legal pages. It is
// intentionally blank — do NOT invent one. While blank, the Terms and Privacy
// pages omit the address line entirely (no placeholder text is shown publicly).
// When the owner supplies the address, fill it in here and both pages pick it up.
export const ORG_LEGAL_NAME = 'Brain Health and Wellness Coach Institute';
export const ORG_MAILING_ADDRESS = ''; // TODO(owner): e.g. '123 Main St, Suite 100, City, ST 00000'

// BOOKING_LINK: the scheduling link offered to schools after they request a
// license. Change it here to change the on-screen "Book a call" button.
//
// NOTE: the confirmation EMAIL is sent server-side and cannot import this file. It
// prefers the BOOKING_LINK environment variable in Netlify (so the emailed link
// can be changed without a deploy) and otherwise falls back to this same URL,
// hardcoded in netlify/functions/license-request.mjs. Keep the two in sync.
export const BOOKING_LINK = 'https://calendar.app.google/X7eLXHgNWZX6VVQv9';
